import { CheckCircle2, Clock, XCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { StatusChip, type StatusTone } from '@/components/ui/Chip';
import { referralReceiptBadge, type ReceiptTone } from '@/lib/referral/referralReceiptDisplay';

const TONE: Record<ReceiptTone, StatusTone> = {
  negative: 'red',
  positive: 'completed',
  waiting: 'draft',
  unknown: 'neutral',
};

function ReceiptIcon({ tone }: { tone: ReceiptTone }) {
  switch (tone) {
    case 'negative':
      return <XCircle className="h-3.5 w-3.5" aria-hidden />;
    case 'positive':
      return <CheckCircle2 className="h-3.5 w-3.5" aria-hidden />;
    case 'waiting':
      return <Clock className="h-3.5 w-3.5" aria-hidden />;
    case 'unknown':
      return null;
    default: {
      const unexpected: never = tone;
      return unexpected;
    }
  }
}

/** Afventer / Positiv / Negativ kvittering with the mockup icon + chip. */
export function ReferralStatusChip({ status }: { status: string }) {
  const { t } = useTranslation();
  const badge = referralReceiptBadge(status);
  return (
    <StatusChip tone={TONE[badge.tone]} className="hv-chip">
      <ReceiptIcon tone={badge.tone} />
      {t(`patients.hospital_referral.${badge.key}`, badge.fallback)}
    </StatusChip>
  );
}
